/* youthfulbloom - product page: gallery, size picking, sticky buy bar. */
(function () {
  var track = document.querySelector('[data-yb-ptrack]');
  var dots = document.querySelector('[data-yb-pdots]');

  function index() {
    return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
  }

  function paint(i) {
    if (!dots) return;
    for (var n = 0; n < dots.children.length; n++) {
      dots.children[n].classList.toggle('is-on', n === i);
    }
  }

  function goTo(i) {
    var max = track.children.length - 1;
    if (i < 0) i = max;                 /* wrap, like the reference */
    if (i > max) i = 0;
    var left = track.clientWidth * i;
    try { track.scrollTo({ left: left, behavior: 'smooth' }); }
    catch (err) { track.scrollLeft = left; }
    paint(i);
  }

  if (track) {
    var t = null;
    track.addEventListener('scroll', function () {
      if (t) clearTimeout(t);
      t = setTimeout(function () { paint(index()); }, 50);
    }, { passive: true });

    document.querySelectorAll('[data-yb-pnav]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        goTo(index() + Number(btn.dataset.ybPnav));
      });
    });

    if (dots) {
      dots.addEventListener('click', function (e) {
        var d = e.target.closest('[data-yb-pdot]');
        if (d) goTo(Number(d.dataset.ybPdot));
      });
    }
  }

  /* ---- size picker ---- */
  var form = document.querySelector('[data-yb-pform]');
  if (!form) return;

  var input = form.querySelector('[data-yb-variant-input]');
  var addBtn = form.querySelector('[data-yb-add-btn]');
  var priceBox = document.querySelector('[data-yb-pprice]');
  var stickyAdd = document.querySelector('[data-yb-sticky-add]');

  var variants = [];
  try {
    variants = JSON.parse(document.querySelector('[data-yb-variant-json]').textContent);
  } catch (err) {}

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function pick(btn) {
    var id = Number(btn.dataset.ybSize);

    form.querySelectorAll('[data-yb-size]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b === btn));
    });
    if (input) input.value = id;

    var v = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === id) { v = variants[i]; break; }
    }
    if (!v) return;

    var label = v.available ? 'Add to cart' : 'Sold out';
    if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = label; }
    if (stickyAdd) { stickyAdd.disabled = !v.available; stickyAdd.textContent = label; }

    if (priceBox) {
      var swatch = priceBox.querySelector('.yb-swatches');
      priceBox.innerHTML = (v.compare_at_price && v.compare_at_price > v.price)
        ? '<mark>' + money(v.price) + '</mark><s>' + money(v.compare_at_price) + '</s>'
        : '<span>' + money(v.price) + '</span>';
      if (swatch) priceBox.appendChild(swatch);   /* keep the colour dot */
    }
  }

  form.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-yb-size]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    pick(btn);
  });

  var pre = form.querySelector('[data-yb-size][aria-pressed="true"]')
         || form.querySelector('[data-yb-size]:not(:disabled)');
  if (pre) pick(pre);

  /* ---- sticky buy bar ----
     Slides up once the real buy row has scrolled off, and submits that same
     form, so there is only ever one source of truth for the variant. */
  var bar = document.querySelector('[data-yb-sticky]');
  var buyRow = form.querySelector('.yb-pbuy');
  if (!bar || !buyRow) return;

  if (stickyAdd) {
    stickyAdd.addEventListener('click', function (e) {
      e.preventDefault();
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(addBtn || undefined);
      } else {
        form.submit();
      }
    });
  }

  function syncBar() {
    /* show it only once the inline button is above the viewport */
    bar.classList.toggle('is-up', buyRow.getBoundingClientRect().bottom < 0);
  }

  window.addEventListener('scroll', syncBar, { passive: true });
  window.addEventListener('resize', syncBar);
  document.addEventListener('DOMContentLoaded', syncBar);
  syncBar();
})();
